import ArrowBack from "../assets/images/arrowBack.svg";
import Cross from "../assets/images/cross.svg";
import Info from "../assets/images/InfoChannels.svg";
import Search from "../assets/images/searchBlack.svg";
import Settings from "../assets/images/settings.svg";
import Dots from "../assets/images/dots.svg";
import {Text} from "../ui-components/text.tsx";
import {FC} from "react";
import {useNavigate} from "react-router-dom";
import clsx from "clsx";

type CustomPageHeaderType = {
    title: string
    onClickInfoAction?: () => void
    onClickBack?: () => void
    type: "EXIT" | "BACK" | "SETTINGS"
    info?: boolean
    settings?: boolean
    modal?: boolean
    border?: boolean
    search?: boolean
    padding_xs?: boolean
    padding_xl?: boolean
}

export const CustomPageHeader: FC<CustomPageHeaderType> = ({
                                                               title,
                                                               info,
                                                               type,
                                                               onClickInfoAction,
                                                               onClickBack,
                                                               settings,
                                                               modal,
                                                               border,
                                                               search,
                                                               padding_xs, padding_xl
                                                           }) => {

    const navigate = useNavigate()
    const backNavigate = () => {
        navigate(-1)
    }
    return (
        <header
            // className="relative flex items-center w-full  bg-white px-[16px] py-[17px]">
            className={clsx('relative flex items-center w-full  bg-white px-6',
                {
                    'shadow-header': border,
                    'py-[9px]': padding_xs,
                    'py-[17px]': !padding_xs,
                    'py-[24px]': padding_xl
                }
            )}>
            {
                type === "BACK"
                    ? <button onClick={onClickBack ?? backNavigate}
                           className="absolute left-6 flex items-center justify-start w-8 h-8">
                        <ArrowBack/>
                    </button> : ''
            }

            <Text className="flex-1 text-center !text-black text-lg !text-[17px] font-semibold">
                {title}
            </Text>
            {
                type === "EXIT" ? <button onClick={() => navigate('/')} className={"w-[14px] h-[14px]"}>
                    <Cross />
                </button> : ''
            }
            {
                info ? <button onClick={onClickInfoAction}>
                    <Info/>
                </button> : ''
            }
            {
                search ? <button onClick={onClickInfoAction}>
                    <Search/>
                </button> : ''
            }
            {
                type === 'SETTINGS' || settings ? <button onClick={onClickInfoAction}>
                    <Settings/>
                </button> : ''
            }
            {
                modal ? <button onClick={onClickInfoAction}>
                    <Dots/>
                </button> : ''
            }
        </header>
    )
}